import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, redirect, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "../../pages/auth/Login";
import Dashboard from "../../pages/dashboard";
import WorkOrder from "../../pages/workOrder";
import WorkOrderNotes from "../../pages/workOrder/WorkOrderNotes"; // <-- NEW
import Appointments from "../../pages/appointments";
import EmptyPage from "../../pages/emptyPage";
import Inspections from "../../pages/inspections";
import TemplateBuilder from "../../pages/templateBuilder";
import Technicians from "../../pages/technicians";
import Update from "../../pages/update";
import ForgotPassword from "../../pages/auth/forgotPage";
import Generatepassword from "../../pages/auth/forgotPage/generatepassword";
import { useSelector } from "react-redux";
import Loading from "../../modal/Loading";
import Profile from "../../pages/profile";
import Cookies from "universal-cookie";
import Role from "../../pages/role";
import Setup from '../../pages/auth/setup/setup';
import Verification from '../../pages/auth/setup/verification';
import BackupVerification from '../../pages/auth/setup/backup-verification';
import User from "../../pages/user";
import Audit from "../../pages/audit";
import SkykitMonitor from '../SkykitMonitor';

const Redirect = ({ to }) => {
  useEffect(() => {
    redirect(to);
  }, [to]);

  return null;
};

const PrivateRoute = ({ children }) => {
  const cookies = new Cookies();
  const tokenC = cookies.get("token");
  const location = useLocation();

  // Redirect to login if no token is found
  if (!tokenC) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

const Index_2 = () => {
  const { loader, user } = useSelector((state) => ({ ...state }));
  return (
    <>
      {loader && <Loading />}
      <ToastContainer theme="colored" autoClose={7000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/verify" element={<Verification />} />
        <Route path="/verify-backup" element={<BackupVerification />} />
        <Route path="/" element={<EmptyPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/generate-password" element={<Generatepassword />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/work-order" element={<PrivateRoute><WorkOrder /></PrivateRoute>} />
        {/* NEW: shareable notes page for a given tranId */}
        <Route path="/workorder/:tranId/notes" element={<PrivateRoute><WorkOrderNotes /></PrivateRoute>} />
        <Route path="/appointments" element={<PrivateRoute><Appointments /></PrivateRoute>} />
        <Route path="/survey-results" element={<PrivateRoute><Inspections /></PrivateRoute>} />
        <Route path="/template-builder" element={<PrivateRoute><TemplateBuilder /></PrivateRoute>} />
        <Route path="/technicians" element={<PrivateRoute><Technicians /></PrivateRoute>} />
        <Route path="/update" element={<PrivateRoute><Update /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/role" element={<PrivateRoute><Role /></PrivateRoute>} />
        <Route path="/user" element={<PrivateRoute><User /></PrivateRoute>} />
        <Route path="/audit" element={<PrivateRoute><Audit /></PrivateRoute>} />
        <Route path="/skykit-monitor" element={<SkykitMonitor />} />
        <Route path="*" element={<h1>Not Found..</h1>} />
      </Routes>
    </>
  );
};

const Index = () => (
  <Router>
    <Index_2 />
  </Router>
);

export default Index;

